import { useEventAttachmentUploadError } from 'entities/Attachment'
import { type MessageFieldStore } from 'widgets/MessageField'

export const useMessageFiledEventAttachmentUploadError = (messageFieldStore: MessageFieldStore) => {
  useEventAttachmentUploadError((data) => {
    messageFieldStore.removeAttachments([data.attachment.id])
  })
}
